
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gc4HO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $8GyO5 = parcelRequire("8GyO5");


var $loej8 = parcelRequire("loej8");


var $czfXc = parcelRequire("czfXc");


var $1nHVU = parcelRequire("1nHVU");


var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $iBsvI = parcelRequire("iBsvI");


var $aXWtB = parcelRequire("aXWtB");


var $ep3mz = parcelRequire("ep3mz");


var $jyA9t = parcelRequire("jyA9t");


var $3OD5k = parcelRequire("3OD5k");


var $kDi7I = parcelRequire("kDi7I");


var $1Tfg5 = parcelRequire("1Tfg5");


var $3WsfO = parcelRequire("3WsfO");


var $caVF7 = parcelRequire("caVF7");


var $alDoy = parcelRequire("alDoy");


var $hxqA6 = parcelRequire("hxqA6");


var $7eOZ4 = parcelRequire("7eOZ4");


var $eCmUm = parcelRequire("eCmUm");


var $1JnRU = parcelRequire("1JnRU");

const $28574250ff4b29d3$var$PAGE_REMIX_ENTRY_POINT = 'objectSidebar';
const $28574250ff4b29d3$var$PAGE_REMIX_SOURCE = 'remixModalFromObjectLevelSidebar';
const $28574250ff4b29d3$export$b855da21ea83ed9 = 'renderer-page-remix';
const $28574250ff4b29d3$var$EMPTY_PAGE_ADF = {
    type: 'doc',
    version: 1,
    content: []
};
const $28574250ff4b29d3$var$publishPageRemixHandoffFailed = ()=>{
    (0, $hdBxM.publish)((0, $k1Pvg.Topics).ROVO_REMIX, {
        type: 'rovo-remix-handoff-failed',
        source: $28574250ff4b29d3$export$b855da21ea83ed9
    });
};
const $28574250ff4b29d3$var$PAGE_REMIX_OBJECT_CONTENT_TYPES = {
    slides: 'slides',
    whiteboard: 'whiteboard',
    database: 'database'
};
const $28574250ff4b29d3$var$getPageRemixObjectCreationContext = (type)=>{
    if (type === 'infographic') return {
        experience: 'remix_object',
        blocks: [
            'infographic'
        ]
    };
    const contentType = $28574250ff4b29d3$var$PAGE_REMIX_OBJECT_CONTENT_TYPES[type];
    return contentType ? {
        experience: 'remix_object',
        contentTypes: [
            contentType
        ]
    } : undefined;
};
const $28574250ff4b29d3$var$constructPageDynamicUiSource = (adfDocument, contentType)=>({
        contentType: contentType,
        startLocalId: '',
        endLocalId: '',
        startIndex: 0,
        endIndex: -1,
        fragmentAdf: (0, $kDi7I.flattenDocContentForPageRemixFragment)(adfDocument),
        fullAdf: adfDocument
    });
/** Remix types that open the AIFC staging modal directly, skipping the thinking bar. */ const $28574250ff4b29d3$var$OPEN_AIFC_MODAL_TYPES = new Set([
    'slides',
    'whiteboard',
    'database'
]);
/**
 * Remix types whose flow never shows the thinking bar, because they hand off somewhere else
 * instead of waiting on a preview.
 *
 * Shared by the `skipThinkingTypes` prop and the Rovo submit path so the two cannot disagree
 * about which types show the bar. Rebuilt per call so it always reflects the current
 * experiment value.
 */ const $28574250ff4b29d3$var$getPageRemixSkipThinkingTypes = ()=>new Set([
        ...$28574250ff4b29d3$var$OPEN_AIFC_MODAL_TYPES,
        'infographic'
    ]);
/**
 * Maps page-level remix types to the forcedContentType value expected by the
 * backend.
 */ const $28574250ff4b29d3$var$PAGE_REMIX_FORCED_CONTENT_TYPE = {
    slides: 'slide',
    whiteboard: 'whiteboard',
    database: 'database'
};
const $28574250ff4b29d3$var$getRemixAifcHandoffExperienceAttributes = ({ type: type, subType: subType, interactionSource: interactionSource, forcedContentType: forcedContentType })=>({
        featureArea: (0, $iBsvI.getRemixFeatureArea)({
            remixType: type,
            existingFeatureArea: 'remix'
        }) ?? 'remix',
        entryPoint: interactionSource,
        remixType: type,
        ...subType && {
            remixSubtype: subType
        },
        ...forcedContentType && {
            aifcObjectType: forcedContentType
        }
    });
const $28574250ff4b29d3$var$PageRemixLifecycleNavigationGuard = ({ cancelActiveRemixRequest: cancelActiveRemixRequest, currentContentId: currentContentId, onClose: onClose, originContentId: originContentId, stopThinking: stopThinking })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!originContentId || !currentContentId || originContentId === currentContentId) return;
        cancelActiveRemixRequest();
        stopThinking();
        onClose({
            remixLifecycleEndReason: 'cancelled'
        });
    }, [
        cancelActiveRemixRequest,
        currentContentId,
        onClose,
        originContentId,
        stopThinking
    ]);
    return null;
};
const $28574250ff4b29d3$var$PageRemixModalImplementation = ({ adfDocument: adfDocument, loadAdfDocument: loadAdfDocument, currentContentId: currentContentId, interactionSource: interactionSource = 'remixModalFromObjectLevelSidebar', onClose: closeModal, onStopThinking: onStopThinking, isEphemeralViewVisible: isEphemeralViewVisible, trigger: trigger, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen, isRemixStartBlocked: isRemixStartBlocked = false, popupRepositionKey: popupRepositionKey, showCascadingHeader: showCascadingHeader = false, presentation: presentation = 'popup', onOpenSidebarConversation: onOpenSidebarConversation, prefetchedAttachmentHiddenOptions: prefetchedAttachmentHiddenOptions, prefetchedSpaceHiddenOptions: prefetchedSpaceHiddenOptions, onAdmitRetainedRemixLifecycle: onAdmitRetainedRemixLifecycle, onObserveLegacyPhase: onObserveLegacyPhase, shouldWaitForRemixHandoffBeforeClose: shouldWaitForRemixHandoffBeforeClose = false, machineLifecycle: machineLifecycle, isLifecycleTreatmentEnabled: isLifecycleTreatmentEnabled, onPageRemixStartRejected: onPageRemixStartRejected, onRemixHandoffIdentityMismatch: onRemixHandoffIdentityMismatch })=>{
    const observationTokenRef = (0, $cozmU.useRef)();
    const abandonedLifecycleObservationTokensRef = (0, $cozmU.useRef)(new Set());
    const lastMachineReadyRemixIdRef = (0, $cozmU.useRef)();
    const handledLifecycleMismatchRemixIdRef = (0, $cozmU.useRef)();
    const onClose = (0, $cozmU.useCallback)((options)=>{
        const reason = options?.remixLifecycleEndReason;
        const token = options && Object.prototype.hasOwnProperty.call(options, 'observationToken') ? options.observationToken : observationTokenRef.current;
        if (token === undefined || !abandonedLifecycleObservationTokensRef.current.has(token)) {
            if (reason === 'handed-off') onObserveLegacyPhase?.('handed-off', undefined, token);
            else if (reason === 'error') onObserveLegacyPhase?.('error', undefined, token);
            else if (reason === 'aborted' || reason === 'cancelled') onObserveLegacyPhase?.('aborted', undefined, token);
            else if (options?.remixLifecycleAlreadySettled) // The staging transfer settled on an accepted INSERTED (CCCEMAU-3624).
            onObserveLegacyPhase?.('inserted', undefined, token);
        }
        // Forward every close option: the staging transfer relies on `preserveRemixLifecycle` and
        // `remixLifecycleAlreadySettled` reaching the lifecycle owner unchanged.
        closeModal(options);
    }, [
        closeModal,
        onObserveLegacyPhase
    ]);
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const resolvedContentId = currentContentId ?? pageContentId;
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const remixDynamicUiContentType = (0, $3OD5k.resolveRemixDynamicUiContentType)(currentContentType);
    const isRemixCancelled = (0, $cozmU.useRef)(false);
    const hasCommittedRemixCreateTerminal = (0, $cozmU.useRef)(false);
    const isDirectOpen = (0, $cozmU.useRef)(false);
    const activeAdfRequestId = (0, $cozmU.useRef)(0);
    const pendingCustomSidebarConversationIdRef = (0, $cozmU.useRef)(undefined);
    const generationConversationChannelIdRef = (0, $cozmU.useRef)(undefined);
    const remixOriginContentIdRef = (0, $cozmU.useRef)(undefined);
    const resolvedContentIdRef = (0, $cozmU.useRef)(resolvedContentId);
    resolvedContentIdRef.current = resolvedContentId;
    const pendingResolvedAdfRef = (0, $cozmU.useRef)(undefined);
    const [isThinking, setIsThinking] = (0, $cozmU.useState)(false);
    const openAIFCStagingModalRef = (0, $cozmU.useRef)(()=>{});
    const remixAifcHandoffExperienceAttributesRef = (0, $cozmU.useRef)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { trackGenerationFailed: trackGenerationFailed, trackGenerationStarted: trackGenerationStarted, trackGenerationStopped: trackGenerationStopped, trackGenerationSucceeded: trackGenerationSucceeded, trackRemixSubmitted: trackRemixSubmitted } = (0, $alDoy.useRemixGenerationAnalytics)();
    const abortRemixAifcHandoffExperience = (0, $cozmU.useCallback)((reason)=>{
        const attributes = remixAifcHandoffExperienceAttributesRef.current;
        if (!attributes) return;
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
            reason: reason,
            attributes: {
                ...attributes,
                reason: reason
            }
        });
        remixAifcHandoffExperienceAttributesRef.current = undefined;
    }, [
        experienceTracker
    ]);
    const cancelActiveRemixRequest = (0, $cozmU.useCallback)((reason = 'User cancelled Remix AIFC handoff')=>{
        isRemixCancelled.current = true;
        activeAdfRequestId.current += 1;
        abortRemixAifcHandoffExperience(reason);
    }, [
        abortRemixAifcHandoffExperience
    ]);
    const unavailableSpaceOptions = (0, $hxqA6.useShouldHideDiagramRemixOption)({
        enabled: prefetchedSpaceHiddenOptions === undefined
    });
    const unavailableAttachmentOptions = (0, $hxqA6.useShouldHideAttachmentRemixOptions)({
        enabled: prefetchedAttachmentHiddenOptions === undefined,
        contentId: resolvedContentId
    });
    const attachmentHiddenOptions = prefetchedAttachmentHiddenOptions ?? unavailableAttachmentOptions;
    const spaceHiddenOptions = prefetchedSpaceHiddenOptions ?? unavailableSpaceOptions;
    const hiddenOptions = spaceHiddenOptions.length > 0 ? [
        ...attachmentHiddenOptions,
        ...spaceHiddenOptions
    ] : attachmentHiddenOptions;
    /**
   * Ends the flow. Use this instead of calling `onStopThinking` directly: `isThinking` has to be
   * cleared on every path that ends the flow, or the thinking bar it drives is left behind.
   */ const stopThinking = (0, $cozmU.useCallback)((options)=>{
        setIsThinking(false);
        onStopThinking(options);
    }, [
        onStopThinking
    ]);
    const hidePopupForTransfer = (0, $cozmU.useCallback)(()=>{
        stopThinking();
        onClose({
            preserveRemixLifecycle: true
        });
    }, [
        onClose,
        stopThinking
    ]);
    const stagingTransfer = (0, $1JnRU.useObjectSidebarStagingTransfer)({
        hidePopup: hidePopupForTransfer
    });
    const settleStagingTransfer = (0, $cozmU.useCallback)((terminal)=>{
        hasCommittedRemixCreateTerminal.current = true;
        stopThinking();
        onClose(terminal === 'inserted' ? {
            remixLifecycleAlreadySettled: true
        } : {
            remixLifecycleEndReason: terminal
        });
    }, [
        onClose,
        stopThinking
    ]);
    const beginStagingTransfer = (0, $cozmU.useCallback)((lifecycle)=>stagingTransfer.begin({
            lifecycle: lifecycle,
            settle: settleStagingTransfer
        }), [
        settleStagingTransfer,
        stagingTransfer
    ]);
    const openModalAndCloseOverlay = (0, $cozmU.useCallback)(()=>{
        hasCommittedRemixCreateTerminal.current = true;
        const pendingCustomSidebarConversationId = pendingCustomSidebarConversationIdRef.current;
        if (pendingCustomSidebarConversationId) {
            pendingCustomSidebarConversationIdRef.current = undefined;
            onOpenSidebarConversation?.(pendingCustomSidebarConversationId);
            stopThinking();
            onClose({
                remixLifecycleEndReason: 'handed-off',
                ...observationTokenRef.current !== undefined && {
                    observationToken: observationTokenRef.current
                }
            });
            // The deferred reply has already finished, so nothing is left generating to hold for.
            (0, $1nHVU.releaseRemixHandoffHold)(pendingCustomSidebarConversationId, 'already-finished');
            return;
        }
        onObserveLegacyPhase?.('previewing', undefined, observationTokenRef.current);
        // Read before closing: ending the flow resets the lifecycle read.
        const previewConversationId = machineLifecycle?.conversationId;
        openAIFCStagingModalRef.current();
        stopThinking();
        onClose({
            remixLifecycleEndReason: 'handed-off',
            ...observationTokenRef.current !== undefined && {
                observationToken: observationTokenRef.current
            }
        });
        // The preview already has its result, so nothing is left generating to hold for.
        if (previewConversationId) (0, $1nHVU.releaseRemixHandoffHold)(previewConversationId, 'already-finished');
    }, [
        machineLifecycle?.conversationId,
        onClose,
        onObserveLegacyPhase,
        onOpenSidebarConversation,
        stopThinking
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, signalActionReady: signalActionReady, resetCompletion: resetCompletion } = (0, $caVF7.useRemixThinkingBarProgress)({
        onOpenPreview: openModalAndCloseOverlay
    });
    const handleLifecycleReady = (0, $cozmU.useCallback)(()=>{
        if (isRemixCancelled.current) return;
        // For types in OPEN_AIFC_MODAL_TYPES, the modal is
        // already open — skip reopening it via onActionReady.
        if (isDirectOpen.current) return;
        (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).ACTION_COMPLETE_RECEIVED);
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_START
        });
        (0, $irnO2.remixGeneratePreviewExperience).success();
        signalActionReady();
    }, [
        signalActionReady,
        experienceTracker
    ]);
    const onActionReady = (0, $cozmU.useCallback)(()=>{
        if (isRemixCancelled.current) return;
        const conversationChannelId = generationConversationChannelIdRef.current;
        generationConversationChannelIdRef.current = undefined;
        trackGenerationSucceeded(conversationChannelId === undefined ? undefined : {
            conversationChannelId: conversationChannelId
        });
        onObserveLegacyPhase?.('ready', undefined, observationTokenRef.current);
        if (!machineLifecycle) handleLifecycleReady();
    }, [
        handleLifecycleReady,
        machineLifecycle,
        onObserveLegacyPhase,
        trackGenerationSucceeded
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: legacyIsRemixError, isRemixAborted: legacyIsRemixAborted, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal } = (0, $7eOZ4.useRemixToAIFC)({
        onActionReady: onActionReady,
        // Staging callbacks are bound per transfer when the modal opens (CCCEMAU-3624).
        stagingAreaTargetMode: 'generating-from-content'
    });
    const isRemixError = machineLifecycle ? machineLifecycle.terminalPhase === 'error' : legacyIsRemixError;
    const isRemixAborted = machineLifecycle ? machineLifecycle.terminalPhase === 'aborted' : legacyIsRemixAborted;
    (0, $cozmU.useEffect)(()=>{
        const remixId = machineLifecycle?.remixId;
        if (machineLifecycle?.phase === 'ready' && remixId !== undefined && lastMachineReadyRemixIdRef.current !== remixId) {
            lastMachineReadyRemixIdRef.current = remixId;
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- signals lifecycle readiness in response to the machine phase, not a local state change
            handleLifecycleReady();
        }
    }, [
        handleLifecycleReady,
        machineLifecycle
    ]);
    (0, $cozmU.useEffect)(()=>{
        const remixId = machineLifecycle?.remixId;
        const conversationId = machineLifecycle?.conversationId;
        if (!machineLifecycle?.isMismatched || remixId === undefined || handledLifecycleMismatchRemixIdRef.current === remixId) return;
        handledLifecycleMismatchRemixIdRef.current = remixId;
        if (machineLifecycle.observationToken !== undefined) abandonedLifecycleObservationTokensRef.current.add(machineLifecycle.observationToken);
        const reason = machineLifecycle.isReleasedByOwner ? 'lifecycle released by owner' : 'lifecycle read mismatch';
        cancelActiveRemixRequest(reason);
        isDirectOpen.current = false;
        pendingCustomSidebarConversationIdRef.current = undefined;
        generationConversationChannelIdRef.current = undefined;
        if (conversationId) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- stops only the mismatched flow's Rovo generation
        stopRemixing(conversationId);
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- closes a flow whose retained lifecycle cannot be read, not a local state change
        stopThinking();
        if (isEphemeralViewVisible) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- closes staging as part of mismatched lifecycle cleanup
        closeAIFCStagingModal();
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: reason,
            attributes: {
                reason: reason
            }
        });
        (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
        (0, $irnO2.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: reason
            }
        });
        onClose({
            ...machineLifecycle.isReleasedByOwner ? {
                remixLifecycleAlreadySettled: true
            } : {
                remixLifecycleEndReason: 'abandoned'
            },
            observationToken: observationTokenRef.current
        });
    }, [
        closeAIFCStagingModal,
        cancelActiveRemixRequest,
        experienceTracker,
        isEphemeralViewVisible,
        machineLifecycle,
        onClose,
        stopThinking,
        stopRemixing
    ]);
    openAIFCStagingModalRef.current = openAIFCStagingModal;
    const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            activeAdfRequestId.current += 1;
            experienceTrackerRef.current.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    reason: 'User closed remix overlay'
                }
            });
            (0, $kDDrf.abortRemixCreateExperienceIfNotCommitted)(experienceTrackerRef.current, hasCommittedRemixCreateTerminal.current);
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: 'User closed remix overlay'
                }
            });
            if (!isDirectOpen.current) abortRemixAifcHandoffExperience('User closed remix overlay');
        };
    }, [
        abortRemixAifcHandoffExperience
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        cancelActiveRemixRequest();
        const reason = 'User closed remix overlay';
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: reason,
            attributes: {
                reason: reason
            }
        });
        (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
        onClose({
            remixLifecycleEndReason: 'cancelled'
        });
    }, [
        cancelActiveRemixRequest,
        experienceTracker,
        onClose
    ]);
    const onRemixFlowActiveChange = (0, $cozmU.useCallback)((active, options)=>{
        if (active) {
            if (isLifecycleTreatmentEnabled || shouldWaitForRemixHandoffBeforeClose) hasCommittedRemixCreateTerminal.current = false;
            isRemixCancelled.current = false;
            isDirectOpen.current = false;
            pendingCustomSidebarConversationIdRef.current = undefined;
            if (options?.shouldShowThinkingBar ?? true) setIsThinking(true);
            // Clear stale completion state from any previous flow.
            resetCompletion();
        } else {
            if (stagingTransfer.isPending()) // The request feeds the open staging preview; the transfer controller settles it.
            return;
            cancelActiveRemixRequest();
            isDirectOpen.current = false;
            pendingCustomSidebarConversationIdRef.current = undefined;
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User cancelled remix thinking',
                attributes: {
                    reason: 'User cancelled remix thinking'
                }
            });
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, 'User cancelled remix thinking');
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: 'User cancelled remix thinking'
                }
            });
            trackGenerationStopped();
            stopRemixing();
            const restartAttributes = {
                entryPoint: $28574250ff4b29d3$var$PAGE_REMIX_ENTRY_POINT,
                remixSource: 'cancelledRemixThinking',
                originalRemixSource: $28574250ff4b29d3$var$PAGE_REMIX_SOURCE,
                product: 'confluence'
            };
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                id: (0, $irnO2.ExperienceName).REMIX_START,
                attributes: restartAttributes
            });
            (0, $kDDrf.startRemixCreateExperience)({
                experienceTracker: experienceTracker,
                attributes: restartAttributes
            });
            stopThinking(shouldWaitForRemixHandoffBeforeClose ? undefined : {
                reopenModal: true
            });
            if (shouldWaitForRemixHandoffBeforeClose) onClose({
                remixLifecycleEndReason: 'cancelled'
            });
        }
    }, [
        stopRemixing,
        stopThinking,
        experienceTracker,
        resetCompletion,
        cancelActiveRemixRequest,
        trackGenerationStopped,
        onClose,
        shouldWaitForRemixHandoffBeforeClose,
        isLifecycleTreatmentEnabled,
        stagingTransfer
    ]);
    const prevIsRemixError = (0, $cozmU.useRef)(isRemixError);
    (0, $cozmU.useEffect)(()=>{
        if (!prevIsRemixError.current && isRemixError && !isRemixCancelled.current) {
            experienceTracker.fail({
                teamName: 'CC CE MAU',
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: new Error('Rovo agent error during remix')
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    reason: 'Rovo agent error during remix'
                }
            });
            trackGenerationFailed();
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- ends the flow in response to Rovo reporting an error, not to a local state change
            stopThinking({
                reopenModal: true
            });
        }
        prevIsRemixError.current = isRemixError;
    }, [
        isRemixError,
        stopThinking,
        experienceTracker,
        trackGenerationFailed
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isRemixCancelled.current && isRemixError && (!shouldWaitForRemixHandoffBeforeClose || !hasCommittedRemixCreateTerminal.current)) {
            if (shouldWaitForRemixHandoffBeforeClose) hasCommittedRemixCreateTerminal.current = true;
            if (isEphemeralViewVisible) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- tears down the flow in response to Rovo reporting an error, not to a local state change
            closeAIFCStagingModal();
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- tears down the flow in response to Rovo reporting an error, not to a local state change
            stopThinking();
            onClose({
                remixLifecycleEndReason: 'error',
                ...isLifecycleTreatmentEnabled && machineLifecycle?.observationToken !== undefined ? {
                    observationToken: machineLifecycle.observationToken
                } : {}
            });
        }
    }, [
        isRemixError,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        stopThinking,
        onClose,
        shouldWaitForRemixHandoffBeforeClose,
        isLifecycleTreatmentEnabled,
        machineLifecycle?.observationToken
    ]);
    // Dismiss the thinking bar and close the popup when the user stops the remix
    // from the Rovo side chat.
    (0, $cozmU.useEffect)(()=>{
        if (isRemixAborted && !isRemixCancelled.current && (!shouldWaitForRemixHandoffBeforeClose || !hasCommittedRemixCreateTerminal.current)) {
            if (shouldWaitForRemixHandoffBeforeClose) hasCommittedRemixCreateTerminal.current = true;
            const reason = 'User stopped from Rovo side chat';
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: reason,
                attributes: {
                    reason: reason
                }
            });
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: reason
                }
            });
            trackGenerationStopped();
            if (isEphemeralViewVisible) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- tears down the flow in response to the user stopping the remix in Rovo, not to a local state change
            closeAIFCStagingModal();
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- tears down the flow in response to the user stopping the remix in Rovo, not to a local state change
            stopThinking();
            onClose({
                remixLifecycleEndReason: isLifecycleTreatmentEnabled && shouldWaitForRemixHandoffBeforeClose ? 'cancelled' : 'aborted',
                ...isLifecycleTreatmentEnabled && machineLifecycle?.observationToken !== undefined ? {
                    observationToken: machineLifecycle.observationToken
                } : {}
            });
        }
    }, [
        isRemixAborted,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        stopThinking,
        onClose,
        experienceTracker,
        trackGenerationStopped,
        isLifecycleTreatmentEnabled,
        shouldWaitForRemixHandoffBeforeClose,
        machineLifecycle?.observationToken
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt, conversationId: conversationId }, options)=>{
        const isLifecycleTreatmentStart = options !== undefined;
        const isMachineBackedStart = options?.isMachineBackedStart ?? false;
        const requestToken = options?.requestToken;
        /**
     * Confirms Rovo accepted the work before this flow can be treated as handed off.
     *
     * A machine-backed start is bound to one authoritative conversation identity, so the
     * send has to come back with that exact identity. An empty or different identity is a
     * failed handoff, not a quiet substitution: publish the failure, record it, and throw
     * so the caller settles through the common truthful-failure path.
     */ const assertHandoffAcknowledged = (resolvedConversationId)=>{
            if (!isMachineBackedStart || !conversationId) return;
            if (resolvedConversationId && resolvedConversationId === conversationId) return;
            onRemixHandoffIdentityMismatch?.('popup-option');
            $28574250ff4b29d3$var$publishPageRemixHandoffFailed();
            throw new Error('Rovo did not acknowledge the Remix handoff for the requested conversation');
        };
        const isCustomOnlyPrompt = type === 'custom' && !subType && !!userPrompt?.trim();
        const shouldDeferCustomOnlyPrompt = isCustomOnlyPrompt;
        const adfRequestId = activeAdfRequestId.current + 1;
        activeAdfRequestId.current = adfRequestId;
        const shouldReuseRovoConversation = !isLifecycleTreatmentStart && Boolean(conversationId);
        const emitsStartSuccessBeforeAwait = isLifecycleTreatmentStart && !shouldDeferCustomOnlyPrompt;
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                remixType: type,
                remixSubtype: subType,
                includesFreegenPrompt: !!userPrompt,
                ...conversationId && {
                    conversationChannelId: conversationId
                }
            }
        });
        const forcedContentType = $28574250ff4b29d3$var$PAGE_REMIX_FORCED_CONTENT_TYPE[type];
        const isRemixAifcHandoff = $28574250ff4b29d3$var$OPEN_AIFC_MODAL_TYPES.has(type);
        const remixAifcHandoffExperienceAttributes = isRemixAifcHandoff ? $28574250ff4b29d3$var$getRemixAifcHandoffExperienceAttributes({
            type: type,
            subType: subType,
            interactionSource: interactionSource,
            forcedContentType: forcedContentType
        }) : undefined;
        if (remixAifcHandoffExperienceAttributes) {
            remixAifcHandoffExperienceAttributesRef.current = remixAifcHandoffExperienceAttributes;
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                id: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                attributes: remixAifcHandoffExperienceAttributes
            });
        }
        (0, $irnO2.remixGeneratePreviewExperience).start();
        (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
        (0, $irnO2.remixGeneratePreviewExperience).addMetadata({
            product: 'confluence',
            interactionSource: interactionSource,
            remixType: type,
            remixSubtype: subType,
            entryPoint: $28574250ff4b29d3$var$PAGE_REMIX_ENTRY_POINT,
            contentType: remixDynamicUiContentType,
            includesFreegenPrompt: !!userPrompt,
            ...type === 'infographic' ? {
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                isConfluenceInfographicsTwoStageEnabled: (0, $iDrrr.fg)('confluence-infographics-two-stage')
            } : {}
        });
        const generationAnalyticsAttributes = {
            contentId: resolvedContentId,
            ...conversationId && {
                conversationChannelId: conversationId
            },
            entryPoint: $28574250ff4b29d3$var$PAGE_REMIX_ENTRY_POINT,
            includesFreegenPrompt: !!userPrompt,
            product: 'confluence',
            remixSource: interactionSource,
            remixSubtype: subType,
            remixType: type
        };
        trackRemixSubmitted(generationAnalyticsAttributes);
        trackGenerationStarted(generationAnalyticsAttributes);
        generationConversationChannelIdRef.current = conversationId;
        let resolvedAdfDocument;
        try {
            if (pendingResolvedAdfRef.current) {
                resolvedAdfDocument = pendingResolvedAdfRef.current;
                pendingResolvedAdfRef.current = undefined;
            } else {
                const sourceAdf = adfDocument ?? $28574250ff4b29d3$var$EMPTY_PAGE_ADF;
                resolvedAdfDocument = sourceAdf instanceof Promise ? await sourceAdf : sourceAdf;
            }
        } catch (error) {
            if (activeAdfRequestId.current !== adfRequestId) return;
            experienceTracker.fail({
                teamName: 'CC CE MAU',
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: error instanceof Error ? error : new Error('Failed to load content for Remix')
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    reason: 'Failed to load content for Remix'
                }
            });
            trackGenerationFailed();
            if (remixAifcHandoffExperienceAttributes) {
                experienceTracker.fail({
                    teamName: 'CC CE MAU',
                    name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                    error: error instanceof Error ? error : new Error('Failed to prepare Remix AIFC handoff'),
                    attributes: remixAifcHandoffExperienceAttributes
                });
                remixAifcHandoffExperienceAttributesRef.current = undefined;
            }
            stopThinking();
            onClose({
                remixLifecycleEndReason: 'cancelled',
                observationToken: requestToken
            });
            return;
        }
        if (activeAdfRequestId.current !== adfRequestId) return;
        const dynamicUiSource = $28574250ff4b29d3$var$constructPageDynamicUiSource(resolvedAdfDocument, remixDynamicUiContentType);
        const additionalCreationContextParams = $28574250ff4b29d3$var$getPageRemixObjectCreationContext(type);
        const promptText = type === 'slides' ? `Remix the selected content as ${(0, $loej8.getTypeDisplayName)(type)}` : undefined;
        const promptArgs = {
            userPrompt: userPrompt,
            promptText: promptText,
            dynamicUiType: type,
            dynamicUiSubtype: subType,
            dynamicUiSource: dynamicUiSource,
            interactionSource: interactionSource,
            additionalCreationContextParams: additionalCreationContextParams,
            ...conversationId ? {
                conversationId: conversationId
            } : {}
        };
        if (!$28574250ff4b29d3$var$OPEN_AIFC_MODAL_TYPES.has(type)) {
            isDirectOpen.current = !shouldDeferCustomOnlyPrompt;
            // A machine-backed start has to await the prompt even before the retained
            // lifecycle has propagated into `shouldWaitForRemixHandoffBeforeClose`, so a
            // native-send rejection can be rethrown and settle the lifecycle as cancelled.
            const shouldWaitForPromptBeforeClose = shouldReuseRovoConversation || shouldWaitForRemixHandoffBeforeClose || isMachineBackedStart;
            // Both the legacy no-wait path and the treatment's early-success path settle
            // REMIX_START before the send resolves, so capture the option before either succeeds.
            const tracksOptionBeforePromptResolution = emitsStartSuccessBeforeAwait || !shouldWaitForPromptBeforeClose;
            if (tracksOptionBeforePromptResolution) (0, $kDDrf.trackRemixCreateOptionSelected)({
                experienceTracker: experienceTracker,
                conversationId: undefined,
                remixType: type,
                remixSubtype: subType,
                includesFreegenPrompt: !!userPrompt
            });
            const promptPromise = sendAIFCPrompt(promptArgs).then((conversationChannelId)=>{
                generationConversationChannelIdRef.current = conversationChannelId;
                if (conversationChannelId && !isRemixCancelled.current && !shouldReuseRovoConversation) {
                    assertHandoffAcknowledged(conversationChannelId);
                    if (shouldDeferCustomOnlyPrompt) pendingCustomSidebarConversationIdRef.current = conversationChannelId;
                    else onOpenSidebarConversation?.(conversationChannelId);
                }
                if (!tracksOptionBeforePromptResolution) (0, $kDDrf.trackRemixCreateOptionSelected)({
                    experienceTracker: experienceTracker,
                    conversationId: conversationChannelId,
                    remixType: type,
                    remixSubtype: subType,
                    includesFreegenPrompt: !!userPrompt
                });
                if (conversationChannelId && !isRemixCancelled.current && !shouldReuseRovoConversation && !shouldDeferCustomOnlyPrompt) (0, $kDDrf.succeedRemixCreateExperienceAtSidebarHandoff)(experienceTracker, presentation === 'popup');
                return conversationChannelId;
            });
            if (emitsStartSuccessBeforeAwait) {
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).REMIX_START
                });
                (0, $irnO2.remixGeneratePreviewExperience).success();
            }
            let conversationChannelId;
            if (shouldWaitForPromptBeforeClose) try {
                conversationChannelId = await promptPromise;
            } catch (error) {
                const isLifecycleAbandoned = isLifecycleTreatmentStart && requestToken !== undefined && abandonedLifecycleObservationTokensRef.current.has(requestToken);
                if (!isLifecycleAbandoned) {
                    if (!isLifecycleTreatmentStart || shouldReuseRovoConversation) trackGenerationFailed();
                }
                if (shouldReuseRovoConversation || isMachineBackedStart) throw error;
                return;
            }
            else // Legacy popup sends settle errors through useRemixToAIFC.
            promptPromise.catch(()=>{});
            if (shouldWaitForPromptBeforeClose) assertHandoffAcknowledged(conversationChannelId);
            if (!shouldDeferCustomOnlyPrompt) {
                if (shouldWaitForPromptBeforeClose && !conversationChannelId) return;
                if (!emitsStartSuccessBeforeAwait) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_START
                    });
                    (0, $irnO2.remixGeneratePreviewExperience).success();
                }
                if (!shouldReuseRovoConversation) {
                    hasCommittedRemixCreateTerminal.current = true;
                    // The popup-mode RemixContainer stays mounted after close and shows its thinking bar
                    // whenever thinking is on, so end thinking here or the bar outlives the handoff.
                    stopThinking();
                    onClose({
                        remixLifecycleEndReason: 'handed-off',
                        observationToken: requestToken
                    });
                }
            }
        } else {
            isDirectOpen.current = true;
            const promptPromise = sendAIFCPrompt({
                ...promptArgs,
                forcedContentType: forcedContentType
            }).then((conversationChannelId)=>{
                generationConversationChannelIdRef.current = conversationChannelId;
                (0, $kDDrf.trackRemixCreateOptionSelected)({
                    experienceTracker: experienceTracker,
                    conversationId: conversationChannelId,
                    remixType: type,
                    remixSubtype: subType,
                    includesFreegenPrompt: !!userPrompt
                });
                if (!isRemixCancelled.current) {
                    const attributes = {
                        ...remixAifcHandoffExperienceAttributes,
                        ...conversationChannelId && {
                            conversationChannelId: conversationChannelId
                        }
                    };
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                        attributes: attributes
                    });
                    (0, $kDDrf.succeedRemixCreateExperienceAtHandoff)(experienceTracker, {
                        ...remixAifcHandoffExperienceAttributes,
                        ...conversationChannelId && {
                            conversationId: conversationChannelId
                        }
                    });
                    remixAifcHandoffExperienceAttributesRef.current = undefined;
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).REMIX_START
                    });
                    (0, $irnO2.remixGeneratePreviewExperience).success();
                    // A machine-backed start is bound to one conversation identity. The awaiting caller
                    // settles a mismatch as a failed handoff, so neither the staging preview nor a
                    // transfer may begin for a flow that is about to be cancelled.
                    const isHandoffAcknowledged = !isMachineBackedStart || !conversationId || conversationChannelId === conversationId;
                    if (isHandoffAcknowledged) {
                        // Staging types keep ownership until the destination acknowledges (CCCEMAU-3624).
                        // The transfer begins before the modal opens so the store's open callback can
                        // never race ahead, and the callbacks handed to this opening are bound to this
                        // transfer alone: a late callback from an earlier modal, or the editor's deferred
                        // insertion acknowledgement, cannot settle a later flow. If openAIFCStagingModal
                        // bails on a cancelled conversation, the abort effect settles the pending transfer.
                        const transferCallbacks = options?.retainedLifecycle ? stagingTransfer.callbacksFor(beginStagingTransfer(options.retainedLifecycle)) : undefined;
                        openAIFCStagingModal({
                            forceFullModal: true,
                            ...transferCallbacks
                        });
                    }
                }
                return conversationChannelId;
            }).catch((error)=>{
                if (!isRemixCancelled.current) {
                    const handoffError = error instanceof Error ? error : new Error('Failed to complete Remix AIFC handoff');
                    experienceTracker.fail({
                        teamName: 'CC CE MAU',
                        name: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF,
                        error: handoffError,
                        attributes: remixAifcHandoffExperienceAttributes
                    });
                    experienceTracker.fail({
                        teamName: 'CC CE MAU',
                        name: (0, $irnO2.ExperienceName).REMIX_START,
                        error: handoffError
                    });
                    (0, $irnO2.remixGeneratePreviewExperience).failure({
                        metadata: {
                            reason: 'Failed to complete Remix AIFC handoff'
                        }
                    });
                    trackGenerationFailed();
                    remixAifcHandoffExperienceAttributesRef.current = undefined;
                }
                if (shouldReuseRovoConversation || isMachineBackedStart) throw error;
                return undefined;
            });
            const shouldWaitForPromptBeforeClose = shouldReuseRovoConversation || shouldWaitForRemixHandoffBeforeClose || isMachineBackedStart;
            if (shouldWaitForPromptBeforeClose) {
                let conversationChannelId;
                try {
                    conversationChannelId = await promptPromise;
                } catch (error) {
                    if (shouldReuseRovoConversation || isMachineBackedStart) throw error;
                    return;
                }
                assertHandoffAcknowledged(conversationChannelId);
                if (!conversationChannelId) return;
            }
            if (options?.retainedLifecycle) return; // settled later by the staging transfer controller
            hasCommittedRemixCreateTerminal.current = true;
            // The popup-mode RemixContainer stays mounted after close and shows its thinking bar
            // whenever thinking is on, so end thinking here or the bar outlives the handoff.
            stopThinking();
            onClose({
                remixLifecycleEndReason: 'handed-off',
                observationToken: requestToken
            });
        }
    }, [
        beginStagingTransfer,
        stagingTransfer,
        sendAIFCPrompt,
        adfDocument,
        interactionSource,
        presentation,
        openAIFCStagingModal,
        onClose,
        stopThinking,
        experienceTracker,
        onOpenSidebarConversation,
        onRemixHandoffIdentityMismatch,
        remixDynamicUiContentType,
        resolvedContentId,
        shouldWaitForRemixHandoffBeforeClose,
        trackGenerationFailed,
        trackGenerationStarted,
        trackRemixSubmitted
    ]);
    const preparePageRemixRequest = (0, $cozmU.useCallback)(async (params, entryPath)=>{
        const startRequestId = activeAdfRequestId.current + 1;
        activeAdfRequestId.current = startRequestId;
        const originContentId = resolvedContentId;
        const admission = {
            outcome: {
                status: 'legacy'
            }
        };
        const startResult = await (0, $1Tfg5.prepareObjectSidebarPageRemixStart)({
            resolveAdfDocument: async ()=>{
                if (loadAdfDocument) return loadAdfDocument();
                if (adfDocument instanceof Promise) return adfDocument;
                return adfDocument ?? null;
            },
            admitLifecycle: onAdmitRetainedRemixLifecycle ? (request)=>{
                const lifecycleAdmission = onAdmitRetainedRemixLifecycle(request);
                admission.outcome = lifecycleAdmission;
                if (lifecycleAdmission.status === 'retained') {
                    observationTokenRef.current = lifecycleAdmission.observationToken;
                    onObserveLegacyPhase?.('thinking', entryPath, lifecycleAdmission.observationToken);
                }
                return lifecycleAdmission.status !== 'rejected';
            } : undefined,
            conversationId: params.conversationId,
            isCurrent: ()=>activeAdfRequestId.current === startRequestId && resolvedContentIdRef.current === originContentId,
            onRejected: (reason)=>onPageRemixStartRejected?.(reason, entryPath)
        });
        if (startResult.status === 'rejected') return startResult;
        const lifecycleAdmission = admission.outcome;
        pendingResolvedAdfRef.current = startResult.adfDocument;
        if (lifecycleAdmission.status === 'retained') {
            remixOriginContentIdRef.current = originContentId;
            return {
                status: 'started',
                lifecycleAdmission: lifecycleAdmission,
                params: {
                    ...params,
                    conversationId: lifecycleAdmission.conversationId
                }
            };
        }
        return {
            status: 'started',
            lifecycleAdmission: lifecycleAdmission,
            params: params
        };
    }, [
        adfDocument,
        loadAdfDocument,
        onAdmitRetainedRemixLifecycle,
        onObserveLegacyPhase,
        onPageRemixStartRejected,
        resolvedContentId
    ]);
    const handleObjectSidebarOptionSelect = (0, $cozmU.useCallback)(async (params)=>{
        const preparedRequest = await preparePageRemixRequest(params, 'popup-option');
        if (preparedRequest.status === 'rejected') {
            stopThinking({
                reopenModal: true
            });
            return;
        }
        try {
            await (0, $1Tfg5.runObjectSidebarPageRemixNativeStart)({
                startNativeRemix: ()=>handleOptionSelect(preparedRequest.params, {
                        isMachineBackedStart: preparedRequest.lifecycleAdmission.status === 'retained',
                        requestToken: preparedRequest.lifecycleAdmission.status === 'retained' ? preparedRequest.lifecycleAdmission.observationToken : undefined,
                        retainedLifecycle: preparedRequest.lifecycleAdmission.status === 'retained' ? preparedRequest.lifecycleAdmission : undefined
                    }),
                onNativeStartRejected: ()=>{
                    stopThinking({
                        reopenModal: true
                    });
                    onClose({
                        remixLifecycleEndReason: 'cancelled',
                        observationToken: preparedRequest.lifecycleAdmission.status === 'retained' ? preparedRequest.lifecycleAdmission.observationToken : undefined
                    });
                }
            });
        } catch  {
        // The native-start wrapper has already restored the picker and settled the lifecycle.
        }
    }, [
        handleOptionSelect,
        onClose,
        preparePageRemixRequest,
        stopThinking
    ]);
    // The picker turns thinking on through `onRemixFlowActiveChange` without the picked type, so
    // `skipThinkingTypes` only covers its uncontrolled state. Once `isThinking` is controlled, record
    // whether the pick skips the bar so a hand-off type never flashes it before the hand-off.
    const isPickerThinkingControlled = isLifecycleTreatmentEnabled || shouldWaitForRemixHandoffBeforeClose;
    const [isPickerThinkingBarSkipped, setIsPickerThinkingBarSkipped] = (0, $cozmU.useState)(false);
    const pickerOptionSelectHandler = isLifecycleTreatmentEnabled ? handleObjectSidebarOptionSelect : handleOptionSelect;
    const handlePickerOptionSelect = (0, $cozmU.useCallback)((params)=>{
        if (isPickerThinkingControlled) setIsPickerThinkingBarSkipped($28574250ff4b29d3$var$getPageRemixSkipThinkingTypes().has(params.type));
        return pickerOptionSelectHandler(params);
    }, [
        isPickerThinkingControlled,
        pickerOptionSelectHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLifecycleTreatmentEnabled && machineLifecycle?.remixId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28574250ff4b29d3$var$PageRemixLifecycleNavigationGuard, {
        cancelActiveRemixRequest: cancelActiveRemixRequest,
        currentContentId: resolvedContentId,
        onClose: onClose,
        originContentId: remixOriginContentIdRef.current,
        stopThinking: stopThinking
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        showLabsLozenge: !(0, $iDrrr.fg)('cc_maui_ga_labs_removal'),
        onClose: handleClose,
        onOptionSelect: handlePickerOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        hideThinkingBar: isPickerThinkingBarSkipped,
        isEphemeralViewVisible: isEphemeralViewVisible,
        skipThinkingTypes: $28574250ff4b29d3$var$getPageRemixSkipThinkingTypes(),
        options: (0, $loej8.PAGE_REMIX_OPTIONS),
        hiddenOptions: hiddenOptions,
        subtitle: (0, $czfXc.default).pageRemixSubtitle,
        cascadingMenuHeader: showCascadingHeader ? {
            title: (0, $czfXc.default).heading,
            subtitle: (0, $czfXc.default).pageRemixSubtitle
        } : undefined,
        presentation: presentation,
        trigger: trigger,
        popupPlacement: popupPlacement,
        popupOffset: popupOffset,
        isPopupOpen: isPopupOpen,
        isOptionSelectBlocked: isRemixStartBlocked,
        popupRepositionKey: popupRepositionKey,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        isThinking: isPickerThinkingControlled ? isThinking : undefined
    }));
};
const $28574250ff4b29d3$var$PageRemixLifecycleTreatmentModal = (props)=>{
    const reportLifecycleDiagnostic = (0, $3WsfO.useObjectSidebarRemixLifecycleDiagnostics)();
    const read = (0, $eCmUm.useObjectSidebarRemixLifecycle)();
    const readRef = (0, $cozmU.useRef)(read);
    readRef.current = read;
    const [retainedFlow, setRetainedFlow] = (0, $cozmU.useState)();
    const retainedFlowRef = (0, $cozmU.useRef)(retainedFlow);
    const reportedMismatchRemixIdRef = (0, $cozmU.useRef)();
    const [matchedRemixId, setMatchedRemixId] = (0, $cozmU.useState)();
    const { onAdmitRetainedRemixLifecycle: admitRetainedRemixLifecycle, onClose: closeTreatmentModal } = props;
    // The owner swaps its close handler once a lifecycle is retained, and admission happens inside
    // the same async submit that later hands off. Delegate to the handler current at call time so
    // the in-flight flow releases the lifecycle it admitted instead of only resetting the UI.
    const closeTreatmentModalRef = (0, $cozmU.useRef)(closeTreatmentModal);
    closeTreatmentModalRef.current = closeTreatmentModal;
    const onClose = (0, $cozmU.useCallback)((options)=>{
        const currentFlow = retainedFlowRef.current;
        if (options && Object.prototype.hasOwnProperty.call(options, 'observationToken') && options.observationToken !== currentFlow?.observationToken) {
            if (options.remixLifecycleEndReason) reportLifecycleDiagnostic('observed', {
                operation: 'duplicateTerminalAttempt',
                terminalReason: options.remixLifecycleEndReason
            });
            return;
        }
        if (options?.preserveRemixLifecycle) {
            closeTreatmentModalRef.current(options);
            return;
        }
        if (currentFlow) {
            retainedFlowRef.current = undefined;
            setRetainedFlow(undefined);
        }
        closeTreatmentModalRef.current(options);
        if (currentFlow && readRef.current.remixId === currentFlow.lifecycle.remixId) readRef.current.dismissTerminal();
    }, [
        reportLifecycleDiagnostic
    ]);
    const onAdmitRetainedRemixLifecycle = (0, $cozmU.useCallback)((request)=>{
        const outcome = admitRetainedRemixLifecycle(request);
        if (outcome.status === 'retained') {
            const nextFlow = {
                lifecycle: outcome.lifecycle,
                observationToken: outcome.observationToken
            };
            retainedFlowRef.current = nextFlow;
            setRetainedFlow(nextFlow);
        }
        return outcome;
    }, [
        admitRetainedRemixLifecycle
    ]);
    const retainedLifecycle = retainedFlow?.lifecycle;
    const isMatch = retainedLifecycle !== undefined && read.hasMachineAuthority && read.remixId === retainedLifecycle.remixId;
    const isMachineAuthority = retainedLifecycle !== undefined || read.hasMachineAuthority;
    const machineRemixId = retainedLifecycle?.remixId;
    const machineConversationId = retainedLifecycle?.conversationId;
    const machineObservationToken = retainedFlow?.observationToken;
    const machinePhase = isMatch ? read.phase : 'inactive';
    const machineTerminalPhase = isMatch ? read.terminalPhase : undefined;
    const machineMismatched = retainedLifecycle !== undefined && !isMatch;
    if (isMatch && matchedRemixId !== retainedLifecycle.remixId) setMatchedRemixId(retainedLifecycle.remixId);
    // A flow the read matched before and now reads as empty was released by the owner (e.g. the Rovo
    // panel closed mid-start), not misread. A read for another remix is still a mismatch.
    const machineReleasedByOwner = machineMismatched && read.remixId === undefined && matchedRemixId === retainedLifecycle.remixId;
    const machineLifecycle = (0, $cozmU.useMemo)(()=>isMachineAuthority ? {
            remixId: machineRemixId,
            conversationId: machineConversationId,
            observationToken: machineObservationToken,
            phase: machinePhase,
            terminalPhase: machineTerminalPhase,
            isMismatched: machineMismatched,
            isReleasedByOwner: machineReleasedByOwner
        } : undefined, [
        isMachineAuthority,
        machineRemixId,
        machineConversationId,
        machineObservationToken,
        machinePhase,
        machineTerminalPhase,
        machineMismatched,
        machineReleasedByOwner
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (retainedLifecycle && !isMatch && !machineReleasedByOwner && reportedMismatchRemixIdRef.current !== retainedLifecycle.remixId) {
            reportedMismatchRemixIdRef.current = retainedLifecycle.remixId;
            reportLifecycleDiagnostic('failed', {
                operation: 'machineReadMismatch'
            });
        }
    }, [
        isMatch,
        machineReleasedByOwner,
        reportLifecycleDiagnostic,
        retainedLifecycle
    ]);
    const onPageRemixStartRejected = (0, $cozmU.useCallback)((reason, entryPath)=>{
        reportLifecycleDiagnostic('rejected', {
            operation: 'preparePageRemixStart',
            entryPath: entryPath,
            rejectionReason: reason
        });
    }, [
        reportLifecycleDiagnostic
    ]);
    const onRemixHandoffIdentityMismatch = (0, $cozmU.useCallback)((entryPath)=>{
        reportLifecycleDiagnostic('failed', {
            operation: 'validateAdmissionIdentity',
            entryPath: entryPath
        });
    }, [
        reportLifecycleDiagnostic
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28574250ff4b29d3$var$PageRemixModalImplementation, {
        ...props,
        onClose: onClose,
        onAdmitRetainedRemixLifecycle: onAdmitRetainedRemixLifecycle,
        onPageRemixStartRejected: onPageRemixStartRejected,
        onRemixHandoffIdentityMismatch: onRemixHandoffIdentityMismatch,
        shouldWaitForRemixHandoffBeforeClose: props.shouldWaitForRemixHandoffBeforeClose || retainedLifecycle !== undefined,
        machineLifecycle: machineLifecycle,
        isLifecycleTreatmentEnabled: true
    });
};
const $28574250ff4b29d3$export$6d573f1103e8ba17 = (props)=>{
    if (props.onAdmitRetainedRemixLifecycle && props.isRemixLifecycleTreatmentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28574250ff4b29d3$var$PageRemixLifecycleTreatmentModal, {
        ...props,
        onAdmitRetainedRemixLifecycle: props.onAdmitRetainedRemixLifecycle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28574250ff4b29d3$var$PageRemixModalImplementation, {
        ...props,
        isLifecycleTreatmentEnabled: false
    });
};
const $28574250ff4b29d3$export$d76041b4fcbfbafa = ({ loadAdfDocument: loadAdfDocument, onOpenSidebarConversation: onOpenSidebarConversation, onClose: onClose = ()=>{}, onStopThinking: onStopThinking = ()=>{}, onAdmitRemixLifecycle: onAdmitRemixLifecycle, onAdmitRetainedRemixLifecycle: onAdmitRetainedRemixLifecycle, onObserveLegacyPhase: onObserveLegacyPhase, isRemixLifecycleTreatmentEnabled: isRemixLifecycleTreatmentEnabled, shouldWaitForRemixHandoffBeforeClose: shouldWaitForRemixHandoffBeforeClose, prefetchedSpaceHiddenOptions: prefetchedSpaceHiddenOptions })=>{
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28574250ff4b29d3$export$6d573f1103e8ba17, {
        loadAdfDocument: loadAdfDocument,
        currentContentId: pageContentId,
        onClose: onClose,
        onStopThinking: onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal,
        onOpenSidebarConversation: onOpenSidebarConversation,
        onAdmitRemixLifecycle: onAdmitRemixLifecycle,
        onAdmitRetainedRemixLifecycle: onAdmitRetainedRemixLifecycle,
        onObserveLegacyPhase: onObserveLegacyPhase,
        isRemixLifecycleTreatmentEnabled: isRemixLifecycleTreatmentEnabled,
        shouldWaitForRemixHandoffBeforeClose: shouldWaitForRemixHandoffBeforeClose,
        prefetchedSpaceHiddenOptions: prefetchedSpaceHiddenOptions
    }));
};
const $28574250ff4b29d3$export$acb8e5953bc27b7e = (props)=>{
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const interactionSource = props.remixModalMetadata?.interactionSource;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28574250ff4b29d3$export$6d573f1103e8ba17, {
        adfDocument: props.adfDocument ?? {
            type: 'doc',
            version: 1,
            content: []
        },
        onClose: props.handleModalClose,
        onStopThinking: props.onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal,
        interactionSource: interactionSource,
        presentation: "modal",
        prefetchedAttachmentHiddenOptions: props.prefetchedAttachmentHiddenOptions,
        prefetchedSpaceHiddenOptions: props.prefetchedSpaceHiddenOptions
    });
};
module.exports["PageRemixModal"] = $28574250ff4b29d3$export$6d573f1103e8ba17;
module.exports["EditorPageRemixModal"] = $28574250ff4b29d3$export$acb8e5953bc27b7e;

});

parcelRegister("kDi7I", function(module, exports) {

var $1qYXT = parcelRequire("1qYXT");


var $6mKj3 = parcelRequire("6mKj3");


var $3rRes = parcelRequire("3rRes");

/** Only invoked for expand node types, so expand-free documents never read the experiment. */ const $75827a28e24fdaa7$var$areRemixExpandsEnabled = ()=>(0, $6mKj3.isExperimentEnabled)((0, $1qYXT.REMIX_EXPANDS_EXPERIMENT));
/**
 * Block types that become direct siblings in page remix `fragmentAdf` after flattening.
 * Containers (layouts, lists, tables, panels, …) are unwrapped so the result matches a
 * linear `doc.content`-style array of block nodes in document order.
 */ const $75827a28e24fdaa7$var$FRAGMENT_ROOT_BLOCK_TYPES = new Set([
    'paragraph',
    'heading',
    'codeBlock',
    'rule'
]);
function $75827a28e24fdaa7$var$flattenRemixFragmentNodes(nodes) {
    if (!nodes?.length) return [];
    const out = [];
    const stack = [
        ...nodes
    ].reverse();
    while(stack.length){
        const node = stack.pop();
        if (!node || typeof node !== 'object' || !('type' in node)) continue;
        const nodeType = String(node.type);
        // Expands are skipped entirely unless REMIX_EXPANDS_EXPERIMENT is on, in which case they
        // fall through to the container branch below and their inner blocks are flattened in like
        // any other container. Page remix has no wrapper to preserve, so the expand title is
        // dropped the same way layout and table wrappers are.
        if ((0, $1qYXT.isRemixRestrictedNodeTypeWithExpands)(nodeType, $75827a28e24fdaa7$var$areRemixExpandsEnabled)) continue;
        if ($75827a28e24fdaa7$var$FRAGMENT_ROOT_BLOCK_TYPES.has(nodeType)) {
            const filtered = (0, $3rRes.filterRemixFragmentNodes)([
                node
            ]);
            if (filtered?.length) out.push(...filtered);
            continue;
        }
        const content = node.content;
        if (content?.length) stack.push(...[
            ...content
        ].reverse());
    }
    return out;
}
function $75827a28e24fdaa7$export$aba2b401f8bd2a68(adfDocument) {
    return $75827a28e24fdaa7$var$flattenRemixFragmentNodes(adfDocument.content ?? []);
}
module.exports["flattenDocContentForPageRemixFragment"] = $75827a28e24fdaa7$export$aba2b401f8bd2a68;

});

parcelRegister("1Tfg5", function(module, exports) {
const $5e79cbfd0491af77$var$isRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);

// Validate with the same options the renderer uses (`editor-common` `validateADFEntity`):
// `stage0`, because Confluence renders pages with the stage-0 ADF schema (see
// `adf-renderer/ADFRendererComponent`) and without it the validator declines stage-0 specs such as
// `layoutSection_with_single_column` (1 to 5 columns, optional column divider); and
// `allowPrivateAttributes`, because Confluence page ADF carries private `__` attributes such as
// `__confluenceMetadata` on internal page links and `__expanded` on expands, which strict validation
// otherwise reports as redundant. Either omission rejects a page the product already renders as
// `malformed-adf`. Structural checks (root type, version, array content) stay in the caller; this only
// decides whether the nodes are valid ADF.
const $5e79cbfd0491af77$var$isSchemaValidAdf = async (value)=>{
    try {
        const { validator: validator } = await Promise.resolve((parcelRequire("3ztIq")));
        return validator(undefined, undefined, {
            stage0: true,
            allowPrivateAttributes: true
        })(value).valid;
    } catch  {
        return false;
    }
};
const $5e79cbfd0491af77$var$hasMeaningfulAdfContent = (node)=>{
    if (node.type === 'text') return typeof node.text === 'string' && node.text.trim().length > 0;
    if (!Array.isArray(node.content)) return node.type !== 'paragraph' && node.type !== 'doc';
    if (node.type !== 'paragraph' && node.type !== 'doc') return true;
    return node.content.some($5e79cbfd0491af77$var$hasMeaningfulAdfContent);
};
const $5e79cbfd0491af77$var$rejectStart = (reason, onRejected)=>{
    onRejected(reason);
    return {
        status: 'rejected',
        reason: reason
    };
};
const $5e79cbfd0491af77$export$4d9ad5af461e64c2 = async ({ resolveAdfDocument: resolveAdfDocument, admitLifecycle: admitLifecycle, conversationId: conversationId, isCurrent: isCurrent, isOpenActionCurrent: isOpenActionCurrent, onRejected: onRejected })=>{
    let resolvedAdf = null;
    try {
        resolvedAdf = await resolveAdfDocument();
    } catch  {
        return $5e79cbfd0491af77$var$rejectStart('adf-load-failed', onRejected);
    }
    if (isOpenActionCurrent && !isOpenActionCurrent()) return $5e79cbfd0491af77$var$rejectStart('stale-open-action', onRejected);
    if (isCurrent && !isCurrent()) return $5e79cbfd0491af77$var$rejectStart('stale-adf', onRejected);
    if (!resolvedAdf) return $5e79cbfd0491af77$var$rejectStart('empty-adf', onRejected);
    if (!$5e79cbfd0491af77$var$isRecord(resolvedAdf) || resolvedAdf.type !== 'doc' || resolvedAdf.version !== 1 || !Array.isArray(resolvedAdf.content) || !await $5e79cbfd0491af77$var$isSchemaValidAdf(resolvedAdf)) return $5e79cbfd0491af77$var$rejectStart('malformed-adf', onRejected);
    if (!resolvedAdf.content.some((node)=>$5e79cbfd0491af77$var$hasMeaningfulAdfContent(node))) return $5e79cbfd0491af77$var$rejectStart('empty-adf', onRejected);
    try {
        if (admitLifecycle && !admitLifecycle({
            conversationId: conversationId
        })) return $5e79cbfd0491af77$var$rejectStart('lifecycle-rejected', onRejected);
    } catch  {
        return $5e79cbfd0491af77$var$rejectStart('lifecycle-rejected', onRejected);
    }
    return {
        status: 'started',
        adfDocument: resolvedAdf
    };
};
const $5e79cbfd0491af77$export$123d27f956fde434 = async ({ startNativeRemix: startNativeRemix, onNativeStartRejected: onNativeStartRejected })=>{
    try {
        await startNativeRemix();
    } catch  {
        onNativeStartRejected();
        throw new Error('Failed to start page remix from Rovo submit');
    }
};
module.exports["prepareObjectSidebarPageRemixStart"] = $5e79cbfd0491af77$export$4d9ad5af461e64c2;
module.exports["runObjectSidebarPageRemixNativeStart"] = $5e79cbfd0491af77$export$123d27f956fde434;

});

parcelRegister("1JnRU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gRoSG = parcelRequire("gRoSG");


var $3WsfO = parcelRequire("3WsfO");

const $8618181253846bb9$export$b3ee91b0ef157d9a = ({ hidePopup: hidePopup })=>{
    const report = (0, $3WsfO.useObjectSidebarRemixLifecycleDiagnostics)();
    const pendingRef = (0, $cozmU.useRef)(undefined);
    const lastSettledRef = (0, $cozmU.useRef)(undefined);
    const [activeRemixId, setActiveRemixId] = (0, $cozmU.useState)(undefined);
    const phase = (0, $gRoSG.useMachinePhase)(activeRemixId ?? '');
    const clear = (0, $cozmU.useCallback)(()=>{
        pendingRef.current = undefined;
        setActiveRemixId(undefined);
    }, []);
    /** The pending transfer, or undefined once the owner no longer holds its lifecycle. */ const current = (0, $cozmU.useCallback)(()=>{
        const pending = pendingRef.current;
        if (!pending) return undefined;
        if (!pending.lifecycle.isCurrent()) {
            clear();
            return undefined;
        }
        return pending;
    }, [
        clear
    ]);
    /**
	 * The pending transfer only when `token` identifies it. Anything else is a callback from a
	 * transfer that already settled or was superseded: report it and let the caller no-op. The one
	 * exception is a callback for the transfer that settled most recently, which the caller may
	 * still want to record as a post-settlement acknowledgement.
	 */ const currentFor = (0, $cozmU.useCallback)((token, callback)=>{
        const pending = current();
        if (pending?.token === token) return pending;
        if (pending || lastSettledRef.current?.token !== token) report('observed', {
            operation: 'staleStagingTransferCallback',
            callback: callback
        });
        return undefined;
    }, [
        current,
        report
    ]);
    const settle = (0, $cozmU.useCallback)((pending, terminal)=>{
        clear();
        lastSettledRef.current = {
            token: pending.token,
            terminal: terminal
        };
        report('observed', {
            operation: 'stagingTransferSettled',
            outcome: terminal
        });
        pending.settle(terminal);
    }, [
        clear,
        report
    ]);
    const begin = (0, $cozmU.useCallback)((transfer)=>{
        const previous = pendingRef.current;
        if (previous) {
            if (previous.lifecycle.isCurrent()) // Single-active admission means a new flow cannot start while the previous one is
            // still owned, so this should be unreachable. Surface it rather than settling the
            // previous transfer through a close handler that may already belong to the new flow.
            report('observed', {
                operation: 'stagingTransferSuperseded'
            });
            clear();
        }
        const token = Symbol('object-sidebar-staging-transfer');
        pendingRef.current = {
            ...transfer,
            token: token,
            previewOpened: false,
            previewOpenQueued: false,
            accepted: false
        };
        setActiveRemixId(transfer.lifecycle.remixId);
        hidePopup();
        return token;
    }, [
        clear,
        hidePopup,
        report
    ]);
    const sendPreviewOpened = (0, $cozmU.useCallback)((pending)=>{
        if (pending.previewOpened) return;
        if (pending.lifecycle.transition({
            type: 'PREVIEW_OPENED'
        })) {
            pending.previewOpened = true;
            pending.previewOpenQueued = false;
            return;
        }
        // PREVIEW_OPENED is legal only from `ready`; the preview can open before the watcher
        // reports RESULT_READY. Retry when the phase changes.
        pending.previewOpenQueued = true;
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Read the ref directly: `current()` may call `clear()`, and a state update inside an effect
        // trips `@atlassian/perf-linting/no-chain-state-updates`. A stale transfer is dropped lazily
        // by the next callback instead.
        const pending = pendingRef.current;
        if (pending?.previewOpenQueued && phase === 'ready' && pending.lifecycle.isCurrent()) sendPreviewOpened(pending);
    }, [
        phase,
        sendPreviewOpened
    ]);
    const previewOpenedFor = (0, $cozmU.useCallback)((token)=>{
        const pending = currentFor(token, 'previewOpened');
        if (pending) sendPreviewOpened(pending);
    }, [
        currentFor,
        sendPreviewOpened
    ]);
    const accept = (0, $cozmU.useCallback)((pending)=>{
        if (pending.accepted) return;
        if (pending.lifecycle.transition({
            type: 'ACCEPTED'
        })) pending.accepted = true;
        else report('observed', {
            operation: 'acceptedRejected'
        });
    }, [
        report
    ]);
    const submittedFor = (0, $cozmU.useCallback)((token)=>{
        const pending = currentFor(token, 'submitted');
        if (!pending) return;
        accept(pending);
        settle(pending, 'handed-off');
    }, [
        accept,
        currentFor,
        settle
    ]);
    const insertionAcknowledgedFor = (0, $cozmU.useCallback)((token)=>{
        const pending = currentFor(token, 'insertionAcknowledged');
        if (!pending) {
            // Submit already settled this transfer (Task 0 precedence rule); keep the over-report visible.
            if (lastSettledRef.current?.token === token) report('observed', {
                operation: 'insertionAcknowledgementAfterSettlement',
                outcome: 'inserted'
            });
            return;
        }
        accept(pending);
        if (pending.accepted) {
            if (pending.lifecycle.transition({
                type: 'INSERTED'
            })) {
                settle(pending, 'inserted');
                return;
            }
            // The destination confirmed the insertion even though the machine would not record it.
            report('observed', {
                operation: 'insertedRejected'
            });
        }
        // A refused ACCEPTED was already reported by accept(); INSERTED was never attempted.
        settle(pending, 'handed-off');
    }, [
        accept,
        currentFor,
        report,
        settle
    ]);
    const insertionNotAcknowledgedFor = (0, $cozmU.useCallback)((token, result)=>{
        const pending = currentFor(token, 'insertionNotAcknowledged');
        if (!pending) {
            if (lastSettledRef.current?.token === token) report('observed', {
                operation: 'insertionAcknowledgementAfterSettlement',
                outcome: result.outcome
            });
            return;
        }
        report('observed', {
            operation: 'insertionNotAcknowledged',
            outcome: result.outcome
        });
        if (result.outcome === 'timed-out-in-flight') // Delivered but unproven: release rather than hold a possible duplicate (3486).
        settle(pending, 'abandoned');
    // Otherwise the recovery UI is still open and the flow stays owned.
    }, [
        currentFor,
        report,
        settle
    ]);
    const previewDismissedFor = (0, $cozmU.useCallback)((token, result)=>{
        const pending = currentFor(token, 'previewDismissed');
        if (!pending) return;
        if (result?.continuedInRovoChat) {
            // The full modal's close and minimize both open Rovo Chat on the conversation, so the
            // generation carries on there. That is the Rovo Chat handoff (CCCEMAU-3623 acknowledgement:
            // conversation opened): hand off with no machine terminal event, never a cancellation.
            settle(pending, 'handed-off');
            return;
        }
        pending.lifecycle.transition({
            type: 'CANCELLED'
        });
        settle(pending, 'cancelled');
    }, [
        currentFor,
        settle
    ]);
    const callbacksFor = (0, $cozmU.useCallback)((token)=>({
            onPreviewOpened: ()=>previewOpenedFor(token),
            onSubmitted: ()=>submittedFor(token),
            onPreviewDismissed: (result)=>previewDismissedFor(token, result),
            editorInsertionAcknowledgement: {
                onAcknowledged: ()=>insertionAcknowledgedFor(token),
                onNotAcknowledged: (result)=>insertionNotAcknowledgedFor(token, result)
            }
        }), [
        insertionAcknowledgedFor,
        insertionNotAcknowledgedFor,
        previewDismissedFor,
        previewOpenedFor,
        submittedFor
    ]);
    const isPending = (0, $cozmU.useCallback)(()=>current() !== undefined, [
        current
    ]);
    // Stable identity: consumers put this object in dependency arrays.
    return (0, $cozmU.useMemo)(()=>({
            begin: begin,
            callbacksFor: callbacksFor,
            isPending: isPending
        }), [
        begin,
        callbacksFor,
        isPending
    ]);
};
module.exports["useObjectSidebarStagingTransfer"] = $8618181253846bb9$export$b3ee91b0ef157d9a;

});


//# sourceMappingURL=RemixObjectPagePopup.6bf904b1.js.map
